import { render, staticRenderFns } from "./CollectionChrome.vue?vue&type=template&id=6d06625a&scoped=true&"
import script from "./CollectionChrome.vue?vue&type=script&lang=js&"
export * from "./CollectionChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06625a",
  null
  
)

export default component.exports